<template lang="pug">
  .component-create-entity-button
    ModalReveal(ref="commonCostModal" :key="key" @input="closeInput")
      slot(slot ="trigger")
        a.fa-stack.fa-lg
          i.fa.fa-circle.fa-stack-2x
          i.fa.fa-plus.fa-stack-1x.fa-inverse
      .body
        .row
          .columns
            label Reason
              textarea(v-model="body.reason")
          .columns
              label Type
                select(v-model="body.common_cost_type_id")
                  option(v-for="costType in commonCostTypes", :value="costType.id") {{costType.name}}
        .row
          .column
            label Tax
              select(v-model="body.tax")
                option(v-for="vat in vats", :value="vat.percentage / 100") {{vat.description }} ({{vat.name}} {{vat.percentage}}%)
            label Add as a debit amount?
            input(type="checkbox", v-model="isDebit" :value="isChecked")
          .column
            VatAmountToggler(v-model="body.amount", label="Amount", :tax="body.tax")

      .row.columns(slot="footer")
        ActionButton(:action="save") Save
</template>
<script type="text/babel">
import ModalReveal from '../../foundation/ModalReveal'
import VatAmountToggler from '../../../backoffice/VatAmountToggler'
import KeplerBackofficeSdk from '../../../../lib/kepler/backoffice'
import MaggieHelper from '../../../../maggieHelper'
import ActionButton from '../ActionButton'
import {mapState} from 'vuex';

export default {
  name: 'AddCommonCostToWallet',
  components: {ActionButton, VatAmountToggler, ModalReveal},
  data() {
    return {
      isDebit: false,
      body: {
        reason: null,
        amount: 0,
        tax: null,
        configuration: 'debt',
        common_cost_type_id:null
      },
      key:0
    }
  },
  created() {
    if (this.cost) {
      Object.assign(this.body, this.cost)
    }
  },
  mounted() {
    this.isChecked()
  },
  watch: {
    isDebit(newVal) {
      if (!newVal) {
        this.body.amount = -this.body.amount
      }
    },
  },
  methods: {
    isChecked() {
      this.body.amount >= 0 ? this.isDebit = false : this.isDebit = true
    },
    closeInput(event) {
      if(!event) {
        this.key++
      }
    },
    save() {

      if (this.isDebit && this.body.amount > 0) {
        this.body.amount = -this.body.amount
      }

      if (this.cost) {
        return this.edit()
      }

      return KeplerBackofficeSdk.commonCosts.make(this.body, (data) => {
        MaggieHelper.notification('Cost', 'Cost added')
        this.$emit('itemUpdated', 'added')
        this.key++
        this.body={
          reason: null,
            amount: 0,
            tax: 0.22,
            configuration: 'debt',
            common_cost_type_id:null
        },
        this.$refs.commonCostModal.close()
      })
    },
    edit() {
      return KeplerBackofficeSdk.commonCosts.select(this.body).edit(this.body, () => {
        this.$emit('itemUpdated')
        this.key++
      })
    }
  },
  computed: {
    ...mapState({
      vats: state => state.configuration.vats,
      commonCostTypes: state => state.configuration.commonCostTypes,
    }),
  },
  props: ['cost']
}
</script>
<style lang="sass" rel="stylesheet/sass">
.component-create-entity-button
  .modal-container
    height: auto
</style>



// WEBPACK FOOTER //
// CommonCostButtonModal.vue?272f86a5